import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/app/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AcceptanceWizard from "@/pages/AcceptanceWizard";
import RepairsList from "@/pages/RepairsList";
import CaseDetail from "@/pages/CaseDetail";
import ItemsList from "@/pages/ItemsList";
import ItemDetail from "@/pages/ItemDetail";
import Customers from "@/pages/Customers";
import Manufacturers from "@/pages/Manufacturers";
import Products from "@/pages/Products";
import Shipments from "@/pages/Shipments";
import WarehousePage from "@/pages/WarehousePage";
import Settings from "@/pages/Settings";
import PublicApproval from "@/pages/PublicApproval";
import ForcePasswordChange from "@/pages/ForcePasswordChange";
import Profile from "@/pages/Profile";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuditLog from "@/pages/AuditLog";
import PublicOutcome from "@/pages/PublicOutcome";
import CameraDiagnostics from "@/pages/CameraDiagnostics";
import CatalogImport from "@/pages/CatalogImport";
import CatalogImportHistory from "@/pages/CatalogImportHistory";
import CatalogConnectivity from "@/pages/CatalogConnectivity";
import CatalogImportGeecom from "@/pages/CatalogImportGeecom";
import BulkManufacturerAssign from "@/pages/BulkManufacturerAssign";
import CustomerImport from "@/pages/CustomerImport";
import QRRedirect from "@/pages/QRRedirect";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (user.must_change_password) return <Navigate to="/cambia-password-obbligatorio" replace />;
  return <Layout>{children}</Layout>;
}

function ForcePwGate({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/password-dimenticata" element={<ForgotPassword />} />
          <Route path="/reimposta-password/:token" element={<ResetPassword />} />
          <Route path="/cambia-password-obbligatorio" element={<ForcePwGate><ForcePasswordChange /></ForcePwGate>} />
          <Route path="/approvazione/:token" element={<PublicApproval />} />
          <Route path="/esito/:token" element={<PublicOutcome />} />
          <Route path="/q/:token" element={<QRRedirect />} />

          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/profilo" element={<Protected><Profile /></Protected>} />
          <Route path="/accettazione" element={<Protected><AcceptanceWizard /></Protected>} />
          <Route path="/pratiche" element={<Protected><RepairsList /></Protected>} />
          <Route path="/pratiche/:id" element={<Protected><CaseDetail /></Protected>} />
          <Route path="/prodotti-in-riparazione" element={<Protected><ItemsList /></Protected>} />
          <Route path="/prodotti/:id" element={<Protected><ItemDetail /></Protected>} />
          <Route path="/clienti" element={<Protected><Customers /></Protected>} />
          <Route path="/produttori" element={<Protected><Manufacturers /></Protected>} />
          <Route path="/catalogo" element={<Protected><Products /></Protected>} />
          <Route path="/spedizioni" element={<Protected><Shipments /></Protected>} />
          <Route path="/magazzino" element={<Protected><WarehousePage /></Protected>} />
          <Route path="/impostazioni" element={<Protected><Settings /></Protected>} />
          <Route path="/impostazioni/registro-attivita" element={<Protected><AuditLog /></Protected>} />
          <Route path="/impostazioni/diagnostica-fotocamera" element={<Protected><CameraDiagnostics /></Protected>} />
          <Route path="/catalogo/import-sito" element={<Protected><CatalogImport mode="website" /></Protected>} />
          <Route path="/catalogo/import-file" element={<Protected><CatalogImport mode="file" /></Protected>} />
          <Route path="/catalogo/storico" element={<Protected><CatalogImportHistory /></Protected>} />
          <Route path="/catalogo/diagnostica" element={<Protected><CatalogConnectivity /></Protected>} />
          <Route path="/catalogo/import-geecom" element={<Protected><CatalogImportGeecom /></Protected>} />
          <Route path="/catalogo/assegnazione-produttore" element={<Protected><BulkManufacturerAssign /></Protected>} />
          <Route path="/clienti/import" element={<Protected><CustomerImport /></Protected>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
